import { QuestionPassStateId } from '../../../learnware/LearnwareEnums';
import { QuestionPassState } from '../QuestionPassState';
export class QuestionPassState_Phase2 extends QuestionPassState {
    id = QuestionPassStateId.Phase2;
    name = 'Vokabeln in Phase 2';
    color = 'primary';
    orderInProgressbar = 8;
}
